"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/naming-convention */
exports.default = {
    rpc: {
        computeFee: {
            description: 'Gets the fee of a chargeable extrinsic operation',
            params: [
                {
                    name: 'op',
                    type: 'ProtocolOp',
                    isOptional: false,
                },
                {
                    name: 'blockHash',
                    type: 'Hash',
                    isOptional: true,
                },
            ],
            type: 'CappedFee',
        },
    },
    types: {},
};
//# sourceMappingURL=definitions.js.map